export default __webpack_public_path__ + "static/media/image-creditcard.b2b53193.svg";